import React from "react";
import ReactDOM from "react-dom";
const StatusModalRender = (props) => {
  return (
    <div className="status_modal_overlay" onClick={() => props.close()}>
      <div className="status_modal adding-content" ref={props.refs}>
        {props.child}
      </div>
    </div>
  );
};

const StatusModal = (props) => {
  return ReactDOM.createPortal(
    <StatusModalRender refs={props.refs} child={props.children} close={props.closeModal}/>,
    document.getElementById("statusModal")
  );
};

export default StatusModal;
